import React from "react";
import {
  BuildingOfficeIcon,
  ChartBarIcon,
  CheckCircleIcon,
  ClockIcon,
  DocumentTextIcon,
  ExclamationTriangleIcon,
  FolderOpenIcon,
  ClipboardDocumentListIcon,
  ChatBubbleLeftRightIcon,
  ScaleIcon,
  ShieldCheckIcon,
} from "@heroicons/react/24/outline";
import TabNavigation from "../ui/TabNavigation";

export const TPRM_TABS = [
  { id: "overview", name: "Overview", icon: ChartBarIcon },
  { id: "vendors", name: "Vendors", icon: BuildingOfficeIcon },
  { id: "assessments", name: "Assessments", icon: ShieldCheckIcon },
  { id: "responses", name: "Responses", icon: ChatBubbleLeftRightIcon },
  { id: "risk-register", name: "Risk Register", icon: ExclamationTriangleIcon },
  { id: "approvals", name: "Approvals", icon: CheckCircleIcon },
  { id: "evidence", name: "Evidence", icon: FolderOpenIcon },
  { id: "contracts", name: "Contracts", icon: DocumentTextIcon },
  { id: "risk-acceptance", name: "Risk Acceptance", icon: ScaleIcon },
  { id: "audit-trail", name: "Audit Trail", icon: ClockIcon },
  {
    id: "questionnaires",
    name: "Questionnaires",
    icon: ClipboardDocumentListIcon,
  },
];

export const TPRM_PLATFORM_ADMIN_TABS = [
  { id: "dashboard", name: "Dashboard", icon: ChartBarIcon },
  { id: "vendors", name: "Vendors", icon: BuildingOfficeIcon },
  {
    id: "questionnaires",
    name: "Questionnaires",
    icon: ClipboardDocumentListIcon,
  },
  { id: "audit-trail", name: "Audit Trail", icon: ClockIcon },
];

export const getTPRMTabsForRole = (platformAdmin) =>
  platformAdmin
    ? TPRM_PLATFORM_ADMIN_TABS
    : TPRM_TABS.filter((tab) => tab.id !== "questionnaires");

export const getTPRMActiveTab = (requestedTab, platformAdmin) => {
  const tabs = getTPRMTabsForRole(platformAdmin);
  const normalizedTab =
    requestedTab === "overview" && platformAdmin
      ? "dashboard"
      : requestedTab === "dashboard" && !platformAdmin
        ? "overview"
        : requestedTab;
  return tabs.some((tab) => tab.id === normalizedTab)
    ? normalizedTab
    : platformAdmin
      ? "dashboard"
      : "overview";
};

const TPRMTabNavigation = ({ activeTab, onTabChange, tabs = TPRM_TABS }) => (
  <TabNavigation
    tabs={tabs}
    activeTab={activeTab}
    onTabChange={onTabChange}
    className="mb-5"
    boxedActive
  />
);

export default TPRMTabNavigation;
